import React from "react";

export const Study = ({ color }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.55556 0C0.705396 0 0 0.705396 0 1.55556V3.11111C0 3.96127 0.705396 4.66667 1.55556 4.66667H12.4444C13.2946 4.66667 14 3.96127 14 3.11111V1.55556C14 0.705396 13.2946 0 12.4444 0H1.55556ZM1.55556 1.55556H12.4444V3.11111H1.55556V1.55556ZM1.55556 6.22222C0.705396 6.22222 0 6.92762 0 7.77778V12.4444C0 13.2946 0.705396 14 1.55556 14H6.22222C7.07238 14 7.77778 13.2946 7.77778 12.4444V7.77778C7.77778 6.92762 7.07238 6.22222 6.22222 6.22222H1.55556ZM10.8889 6.22222C10.0387 6.22222 9.33333 6.92762 9.33333 7.77778V12.4444C9.33333 13.2946 10.0387 14 10.8889 14H12.4444C13.2946 14 14 13.2946 14 12.4444V7.77778C14 6.92762 13.2946 6.22222 12.4444 6.22222H10.8889ZM1.55556 7.77778H6.22222V12.4444H1.55556V7.77778ZM10.8889 7.77778H12.4444V12.4444H10.8889V7.77778Z"
        fill={color || "#605DAF"}
      />
    </svg>
  );
};
